module.exports = "<div>\n  <p>&copy; Система диагностики профессиональных компетенций (Траектория), {{ new Date().getFullYear() }}</p>\n  <br/>\n</div>\n";